import { OIDC_ENABLED } from "../config/auth-features";
import { isIssuerIdTokenExpired } from "./issuer-claims";
import { beginSilentLogin, storedIssuerIdToken } from "./oidc-auth";

/**
 * Start a silent sign-in (`prompt=none`, ISC-403) back to the current page,
 * but only when this browser holds an issuer id_token that is provably past
 * its `exp`: the user had a session, and the platform SSO cookie may still be
 * live (1 h token vs the SSO session). Used at boot and when a mid-session 401
 * cannot be re-exchanged.
 *
 * Never for a visitor holding no token, so an anonymous page is never bounced
 * to the issuer. Not under AUTH_MODE=cognito, where there is no issuer config.
 * beginSilentLogin itself refuses while a logout is in flight or a previous
 * attempt is still suppressed, so this cannot loop.
 *
 * Returns true when a navigation is under way; the caller must stop there.
 */
export async function beginSilentReauthIfExpired(): Promise<boolean> {
  if (!OIDC_ENABLED || typeof window === "undefined") return false;
  const idToken = storedIssuerIdToken();
  if (!idToken || !isIssuerIdTokenExpired(idToken)) return false;
  const { pathname, search, hash } = window.location;
  return beginSilentLogin(`${pathname}${search}${hash}`);
}
